export const locale = {
    lang: 'en',
    data: {
        NAV: {
            DASHBOARD: 'Dashboard',
            CLIENTS: 'Clients',
            NEW_CLIENT: 'New client',
            NEW_CLIENT_LEADSHOP: 'Leadshop client',
            CONTRACTS: {
                CONTRACTS: 'Contracts',
                LIST: 'List',
                NEW: 'Create',
            },
            ADVISORS: {
                ADVISORS: 'Advisors',
                LIST: 'List',
                TREE: 'Tree',
                MANUFACTORY: 'Manufactory',
                NEW: 'Create',
            },
            REPORTS: {
                TITLE: 'Reports',
                ADVISORS: 'Advisors\'',
            },
        }
    }
};
